<template>
	<section class="section">
		<form id="edit" class="container">
			<div class="field">
				<label class="label" for="name">Name:</label>
				<input class="input" v-model="recipe.name" name="name" type="text" placeholder="" />
			</div>
			<div class="field">
				<label class="label" for="category">Category:</label>
				<input class="input" v-model="recipe.category" name="category" type="text" placeholder="Category" />
			</div>
			<div class="field">
				<label class="label" for="category">Tags:</label>
				<input class="input" v-model="recipe.tags" name="tags" type="text" placeholder="Comma separated tags" />
			</div>
			<div class="field">
				<label class="label" for="servings">Servings:</label>
				<input class="input" v-model.number="recipe.servings" name="servings" type="number" placeholder="Servings" />
			</div>
			<div class="field">
				<label class="label" for="preptime">Prep time (minutes):</label>
				<input class="input" v-model.number="recipe.preptime" number name="preptime" type="text" placeholder="Prep time" />
			</div>
			<div class="field">
				<label class="label" for="cooktime">Cooking Time (minutes)</label>
				<input class="input" v-model.number="recipe.cooktime" number name="cooktime" type="text" placeholder="Cooking time" />
			</div>
			<div class="field">
				<label class="label" for="source">Source:</label>
				<input class="input" v-model="recipe.source" name="source" type="text" placeholder="Source" />
			</div>
			<div class="field">
				<label class="label" for="ingredients">Ingredients:</label>
				<textarea class="textarea" v-model="recipe.ingredients" name="ingredients"></textarea>
			</div>
			<div class="field">
				<label class="label" for="instructions">Instructions:</label>
				<div class="control">
					<textarea class="textarea" v-model="recipe.instructions" name="instructions"></textarea>
				</div>
			</div>
			<div class="field">
				<label class="label" for="notes">Notes:</label>
				<textarea class="textarea" v-model="recipe.notes" name="notes"></textarea>
			</div>
			<div class="columns is-mobile">
				<div class="column">
					<a class="button is-success is-outlined" v-on:click="save">Save</a>
				</div>
				<div class="column has-text-centered">
					<a class="button is-danger is-outlined" v-on:click="confirmDelete">Delete</a>
				</div>
				<div class="column has-text-right">
					<a class="button is-dark is-outlined" v-on:click="cancel">Cancel</a>
				</div>
			</div>
			<!--p><pre>data: {{ $data }}</pre></p-->
		</form>
	</section>
</template>

<script>
	import {db} from '@/variables.js'

	export default {
		props: ['id'],
		data: function () {
			return {
				recipe: {}
			}
		},
		created: function() {
			this.fetchData()
		},
		watch: {
			// call fetchData again if the route changes
			'$route': 'fetchData'
		},
		methods: {
			fetchData: function() {
				var vm = this

				db.get(vm.id).then(function(response){
					console.log(response)

					var recipe = response
					if( Array.isArray( recipe.tags ) )
					{
						recipe.tags = recipe.tags.join(', ')
					}
					if( Array.isArray( recipe.instructions ) )
					{
						recipe.instructions = recipe.instructions.join('\n')
					}
					if( Array.isArray( recipe.ingredients ) )
					{
						recipe.ingredients = recipe.ingredients.join('\n')
					}

					vm.recipe = recipe
				}).catch(function(err){
					alert(err.message)
					console.log(err)
				})
			},
			save: function() {
				var vm = this

				if (this.recipe.name)
				{
					this.recipe.name = this.recipe.name.trim()
				}

				if (this.recipe.category)
				{
					this.recipe.category = this.recipe.category.trim()
				}

				if( this.recipe.tags )
				{
					this.recipe.tags = this.recipe.tags.split(',')
					for( var idx in this.recipe.tags )
					{
						this.recipe.tags[idx] = this.recipe.tags[idx].trim()
					}
					this.recipe.tags.sort()
				}

				if (this.recipe.ingredients)
				{
					this.recipe.ingredients = this.recipe.ingredients.split('\n')
				}

				if (this.recipe.instructions)
				{
					this.recipe.instructions = this.recipe.instructions.split('\n')
				}

				db.post(this.recipe).then(function(response){
					console.log(response)
					vm.$router.go(-1)
				}).catch(function(error){
					alert(error.message)
					console.log(error)
				})
			},
			cancel: function() {
				if (window.confirm("Press OK to discard any changes to this recipe"))
				{
					this.$router.go(-1)	
				}
			},
			confirmDelete: function() {
				if (window.confirm("You are about to DELETE this recipe."))
				{
					var vm = this
					db.get(vm.id).then( function( doc ) {
						return db.remove( doc );
					}).then( function( response ) {
						console.log( response )
						vm.$router.push('/')
					}).catch( function( error ) {
						alert( error.message )
					})
				}
			}
		}
	}
</script>
